export default {
  'Teklif Formu': 'Offertformulär',
  'Kayıtlı Teklifler': 'Sparade Offerter',
  'Kullanıcı Adı': 'Användarnamn',
  'Şifre': 'Lösenord',
  'Giriş Yap': 'Logga in',
  'Çıkış Yap': 'Logga ut',
  'KDV Oranı': 'Momsprocent',
  'Teklif Durumu': 'Offertstatus',
  'Kaydet': 'Spara',
  'PDF Önizleme': 'PDF Förhandsvisning',
  'PDF\'ye Aktar': 'Exportera till PDF',
  'E-posta ile Gönder': 'Skicka via Email',
  'Alıcı': 'Mottagare',
  'Tarih': 'Datum',
  'Genel Toplam': 'Totalt Belopp',
  'Not': 'Anteckning',
  'KDV': 'Moms',
  'Alt Toplam': 'Delsumma',
  'Açıklama': 'Beskrivning',
  'Ürün Adı': 'Produktnamn',
  'SUT Kodu': 'SUT-kod',
  'Birim Alış Fiyatı': 'Enhetspris',
  'Sipariş Adedi': 'Beställningsantal',
  'Promosyon Ürün': 'Kampanjprodukt',
  'Toplam Adet': 'Totalt Antal',
  'Sipariş Tutarı': 'Beställningsbelopp',
  'Durum': 'Status',
  'Kabul Edildi': 'Godkänd',
  'Reddedildi': 'Avvisad',
  'Gönderildi': 'Skickad',
  'Taslak': 'Utkast',
  'Yurtiçi': 'Inhemsk',
  'Yurtdışı': 'Internationell',
  'Sipariş Oluştur': 'Skapa Beställning',
  'Ürün Sıralaması': 'Produktsortering',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': 'Produkter sorteras efter popularitet och viktighetsnivå',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': 'Kardiologi- och kärlkirurgiprodukter visas som prioriterade',
  'Ürün adı, açıklama veya barkod ile ara...': 'Sök efter produktnamn, beskrivning eller streckkod...',
  'Tüm Kategoriler': 'Alla Kategorier',
  'Kutu görünüm': 'Rutnätsvy',
  'Liste görünüm': 'Listvy',
  'Aradığınız kriterlere uygun ürün bulunamadı': 'Inga produkter hittades som matchar dina kriterier',
  'Ürün Adı Yok': 'Inget Produktnamn',
  'Kategori Yok': 'Ingen Kategori',
  'Açıklama yok': 'Ingen beskrivning',
  'Firma Bilgilerini Doldurun': 'Fyll i Företagsinformation',
  'Sepete Ekle': 'Lägg till i Kundvagn',
  'Firma Bilgileri': 'Företagsinformation',
  'Ülke Seçimi': 'Landsval',
  'Türkiye': 'Turkiet',
  'Almanya': 'Tyskland',
  'ABD': 'USA',
  'Firma Ünvanı': 'Företagsnamn',
  'Vergi Dairesi': 'Skatteverket',
  'Vergi Numarası': 'Organisationsnummer',
  'Adres': 'Adress',
  'Şehir': 'Stad',
  'Yetkili': 'Behörig Person',
  'Telefon': 'Telefon',
  'Email': 'Email',
  'Bilgileri İlet': 'Skicka Information',
  'Lütfen eksik alanları doldurun': 'Vänligen fyll i tomma fält',
  'Firma kaydedilemedi': 'Företaget kunde inte sparas',
  'Firma bilgileri başarıyla iletildi': 'Företagsinformation skickades framgångsrikt',
  'Firma Ünvanı:': 'Företagsnamn:',
  'Yetkili Kişi:': 'Behörig Person:',
  'Sepetiniz': 'Din Kundvagn',
  'Sepetiniz boş': 'Din kundvagn är tom',
  'adet': 'st',
  'Düzenle': 'Redigera',
  'Kaldır': 'Ta bort',
  'Siparişi Tamamla': 'Slutför Beställning',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'Vänligen skicka komplett företagsinformation först',
  'Sipariş başarıyla kaydedildi': 'Beställningen sparades framgångsrikt',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'Välkomstmeddelande och åtkomstlänk skickades till din email',
  'Link 3 gün geçerlidir': 'Länken är giltig i 3 dagar',
  'Sipariş kaydedilemedi': 'Beställningen kunde inte sparas',
  'Firma Bilgileri Gerekli': 'Företagsinformation Krävs',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'Fyll i företagsinformation först för att lägga till i kundvagn',
  'Önce Bilgileri Doldurun': 'Fyll i Information Först',
  'Uyarı': 'Varning',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'Du måste fylla i företagsinformation först för att lägga till i kundvagn',
  'SUT Kütüphanesi Tanımı': 'SUT-bibliotekets Definition',
  'SUT Kodu:': 'SUT-kod:',
  'Standart': 'Standard',
  'Açıklama (isteğe bağlı)': 'Beskrivning (valfritt)',
  'Partner Ol': 'Bli Partner',
  'Partner başvuru popup açılacak': 'Partneransöknings-popup öppnas',
  'Dil': 'Språk',
  'E-posta': 'Email',
  'globalPartnersTitle': 'Samarbete med 30.000 Partners över Hela Världen',
  'globalPartnersDesc': 'Vårt omfattande globala nätverk av 30.000 partners främjar gemensam innovation, kunskapsdelning och ömsesidig framgång. Tillsammans utökar vi kontinuerligt gränserna för patientsjukvård.',
  'bayiBasvuru': 'INVAMED Partneransökningsformulär',
  'bayiBasvuruDesc': 'Fyll i formuläret nedan för att ansluta till INVAMED-partnernätverket. Efter att din ansökan granskats kommer vi att kontakta dig.',
  'applyFields': {
    'firma': 'Företagsnamn',
    'vergiNo': 'Skatteverket / Organisationsnummer',
    'yetkili': 'Behörig Persons Fullständiga Namn',
    'telefon': 'Telefon',
    'email': 'Email',
    'adres': 'Adress',
    'sektor': 'Verksamhetsområde / Sektor',
    'sicil': 'Registreringsnummer',
    'web': 'Webbplats'
  },
  'Şifremi Unuttum': 'Glömt Lösenord',
  'Demo Giriş': 'Demo Inloggning',
  'Bayi Başvurusu': 'Partneransökan',
  'Yardım': 'Hjälp',
  'Giriş yapılıyor...': 'Loggar in...',
  'E-posta veya şifre hatalı': 'Felaktig email eller lösenord',
  'Şifre sıfırlama e-postası gönderildi': 'Lösenordsåterställnings-email skickades',
  'E-posta gönderilemedi': 'Email kunde inte skickas',
  'Vergi Dairesi / Vergi No': 'Skatteverket / Organisationsnummer',
  'Yetkili Adı Soyadı': 'Behörig Persons Fullständiga Namn',
  'Faaliyet Alanı / Sektör': 'Verksamhetsområde / Sektor',
  'Ticaret Sicil No': 'Registreringsnummer',
  'Web Sitesi': 'Webbplats',
  'Temel Bilgiler': 'Grundläggande Information',
  'Ek Bilgiler': 'Ytterligare Information',
  'Başvuru Gönder': 'Skicka Ansökan',
  'Başvuru gönderiliyor...': 'Skickar ansökan...',
  'Başvuru başarıyla gönderildi': 'Ansökan skickades framgångsrikt',
  'Başvuru gönderilemedi': 'Ansökan kunde inte skickas',
  'Sözleşme şartlarını kabul ediyorum': 'Jag accepterar avtalsvillkoren',
  'Dosya Yükle': 'Ladda upp Fil',
  'Dosya seçilmedi': 'Ingen fil vald',
  'Dosya yüklendi': 'Filen laddades upp framgångsrikt',
  'Dosya yüklenemedi': 'Filen kunde inte laddas upp',
  'Tamamla': 'Slutför',
  'Geri': 'Tillbaka',
  'İleri': 'Nästa',
  'Kapat': 'Stäng',
  'Yardım İçeriği': 'Hjälpinnehåll',
  'dil': 'Språk',
  'Üye Ol': 'Registrera dig',
  'Üye Değil Misiniz?': 'Inte Registrerad?',
  'Şimdi Üye Ol': 'Registrera dig Nu',
  'Misafir Kullanıcı': 'Gästanvändare',
  'Hızlı Sipariş': 'Snabb Beställning',
  'Misafir Olarak Sipariş Verin': 'Gör Beställning som Gäst',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'Välj snabbt dina produkter och skapa din beställning utan inloggning',
  'Giriş yapmadan sipariş oluşturun': 'Skapa beställning utan inloggning',
  'Anında Erişim': 'Omedelbar Åtkomst',
  'Tüm ürünlere anında erişim': 'Omedelbar åtkomst till alla produkter',
  'Güvenli İşlem': 'Säker Transaktion',
  'SSL korumalı güvenli sipariş': 'Säker beställning med SSL-skydd',
  'Misafir Olarak Sipariş Oluştur': 'Skapa Beställning som Gäst',
  'İpucu:': 'Tips:',
  'Daha fazla özellik için üye olun': 'Registrera dig för fler funktioner',
  'Ücretsiz': 'Gratis',
  'Hızlı': 'Snabb',
  'Güvenli': 'Säker',
  'bayilikSozlesme': 'Jag har läst och accepterar villkoren och partneravtalet.',
  'geri': 'Tillbaka',
  'basvuruGonder': 'Skicka Ansökan',
  'ileri': 'Nästa',
  'sozlesmeGonderildi': 'Avtal Skickat till Din Email!',
  'sozlesmeDesc': 'Vänligen ladda upp INVAMED Partneravtalet och nödvändiga dokument som skickats till din email.',
  'tamamla': 'Slutför Ansökan',
  'basvuruAlindi': 'Din Ansökan Mottagen!',
  'basvuruAlindiDesc': 'INVAMED-teamet kommer att granska din ansökan och kontakta dig så snart som möjligt.',
  'Başvuru Durumu': 'Ansökningsstatus',
  'Başvurunuz onay sürecindedir': 'Din ansökan granskas',
  'sifreSifirla': 'Återställ Lösenord',
  'sifreSifirlaDesc': 'Ange din registrerade email, vi skickar instruktioner för lösenordsåterställning.',
  'gonder': 'Skicka',
  'talimatGonderildi': 'Instruktioner Skickade',
  'sentDesc': 'Lösenordsåterställningsinstruktioner skickades till <b>{email}</b>. Vänligen kontrollera din email.',
  'helpTitle': 'Hur Kan Jag Logga In?',
  'helpList': [
    'För att logga in på INVAMED partner-panelen, ange din registrerade email och lösenord.',
    'För att logga in med demo-användare:',
    'Om du har glömt ditt lösenord kan du begära återställning via länken "Glömt Lösenord".',
    'Om du har problem med inloggning, se till att du anger rätt email och lösenord. Om problemet kvarstår, kontakta vårt support-team.'
  ],
  'partnerlikSozlesmeTitle': 'INVAMED Partneravtal och Villkor',
  'partnerlikSozlesmeText': `1. ALLMÄNNA BESTÄMMELSER

Detta avtal ingås mellan INVAMED (härefter "Företaget") och partnerkandidat (härefter "Partner") för samarbete inom försäljning av medicinsk utrustning och tillbehör.

2. PARTNERSKAPSVILLKOR

2.1. Partner måste ha juridisk behörighet för försäljning av medicinsk utrustning.
2.2. Partner måste vara en organisation som verkar inom hälso- och sjukvårdssektorn.
2.3. Partner måste ha nödvändiga licenser och certifikat.
2.4. Partner måste vara finansiellt pålitlig.

3. PARTERNAS FÖRPLIKTELSER

Företagets förpliktelser:
3.1. Tillhandahålla högkvalitativ produkt och tjänster
3.2. Tillhandahålla teknisk support
3.3. Genomföra utbildning och information
3.4. Vara transparenta i prissättning

Partners förpliktelser:
3.1. Förvara produkter under lämpliga förhållanden
3.2. Tillhandahålla högkvalitativ kundservice
3.3. Följa juridiska regler
3.4. Skydda företagets varumärke

4. PRISSÄTTNING OCH BETALNING

4.1. Priser fastställs av Företaget
4.2. Partner är skyldig att följa fastställda priser
4.3. Betalningsvillkor bestäms separat
4.4. Provisionssatser kan variera beroende på prestation

5. KONFIDENTIALITET OCH SÄKERHET

5.1. Parterna är skyldiga att skydda varandras konfidentiella information
5.2. Kundinformation måste hållas konfidentiell
5.3. Måste följa dataskyddsstandarder

6. AVTALETS VARAKTIGHET OCH UPPSÄGNING

6.1. Detta avtal gäller i 1 år
6.2. Kan förlängas med ömsesidigt samtycke
6.3. Kan sägas upp med 30 dagars uppsägningstid
6.4. Kan sägas upp omedelbart vid allvarligt avtalsbrott

7. TVISTELÖSNING

7.1. Tvister försöker lösas först genom förhandlingar
7.2. I fall som inte kan lösas är Turkiska republikens domstolar behöriga

8. IKRAFTTRÄDANDE

Detta avtal har lästs, förståtts och accepterats av parterna. Jag förklarar att jag accepterar alla bestämmelser i detta avtal och kommer att uppfylla mina förpliktelser.`,
  'partnerlikSozlesmeOnay': 'Jag har läst, förstått och accepterat INVAMED Partneravtal och Villkor ovan. Jag förklarar att jag accepterar alla bestämmelser i detta avtal och kommer att uppfylla mina förpliktelser.',
  'sozlesmeyiGoruntule': 'Visa Avtal',
  'sozlesmeyiKapat': 'Stäng',
  'Ürün': 'Produkt',
  'Ürün eklemek için ürün listesinden seçim yapın': 'Välj från produktlistan för att lägga till produkt',
  'Etiketler': 'Etiketter',
  'Öncelikli': 'Prioriterad',
  'Ülke Seçiniz': 'Välj Land',
  'Firma / Sağlık Profesyoneli': 'Företag / Hälso- och Sjukvårdspersonal',
  'Şehir Seçiniz': 'Välj Stad',
  'Yetkili Kişi': 'Behörig Person',
  'UDI Kodu': 'UDI-kod',
  'Teklif başarıyla kaydedildi!': 'Offerten sparades framgångsrikt!',
  'Aynı teklif zaten kayıtlı!': 'Samma offert är redan sparad!',
  'Kullanıcı adı veya şifre hatalı!': 'Felaktigt användarnamn eller lösenord!',
  'Teklif No': 'Offertnummer',
  'Teklifler': 'Offerter',
  'Yedeklenecek teklif yok!': 'Inga offerter att säkerhetskopiera!',
  'Yedek dosyası indirildi.': 'Säkerhetskopieringsfilen laddades ner.',
  'Yedek başarıyla yüklendi.': 'Säkerhetskopian laddades framgångsrikt.',
  'Geçersiz veya bozuk dosya!': 'Ogiltig eller skadad fil!',
  'Yedekle (JSON)': 'Säkerhetskopiera (JSON)',
  'Geri Yükle': 'Återställ',
  'Kayıtlı teklif yok.': 'Inga sparade offerter.',
  'E-posta Durumu': 'Email-status',
  'İşlemler': 'Transaktioner',
  'E-posta ile gönderildi': 'Skickad via email',
  'E-posta gönderilmedi': 'Email skickades inte',
  'Görüntüle': 'Visa',
  'Sil': 'Ta bort',
  'Gönderildi': 'Skickad',
  'Gönderilmedi': 'Inte skickad',
  'Teklif ID bulunamadı! Lütfen tekrar deneyin.': 'Offert-ID hittades inte! Vänligen försök igen.',
  'Lütfen partner seçiniz.': 'Vänligen välj partner.',
  'Lütfen teslimat tarihi belirtiniz.': 'Vänligen ange leveransdatum.',
  'Proforma başarıyla oluşturuldu!': 'Proforma skapades framgångsrikt!',
  'Proforma oluşturuldu ancak ürün eklenemedi. Detaylar için konsolu kontrol edin.': 'Proforma skapades men produkt kunde inte läggas till. Kontrollera konsolen för detaljer.',
  'Link başarıyla silindi': 'Länken togs bort framgångsrikt',
  'Link kopyalandı!': 'Länken kopierades!',
  'Ödeme durumu başarıyla güncellendi!': 'Betalningsstatus uppdaterades framgångsrikt!',
  'dosyası okunamadı!': 'filen kunde inte läsas!',
  'Tüm dosyalar için SUT kodu ve fiyat kolonlarını seçmelisiniz!': 'Du måste välja SUT-kod och pris-kolumner för alla filer!',
  'Yüklenecek geçerli satır bulunamadı! Lütfen dosya(lar)da SUT kodu ve fiyatı dolu satır olduğundan emin olun.': 'Inga giltiga rader att ladda hittades! Se till att det finns rader med ifylld SUT-kod och pris i filen.',
  'Yükleme sırasında hata oluştu!': 'Ett fel uppstod under uppladdning!',
  'Otomatik etiket ekleme başarısız!': 'Automatisk etikettläggning misslyckades!',
  'Etiketler başarıyla güncellendi!': 'Etiketter uppdaterades framgångsrikt!',
  'Etiketler güncellenirken hata oluştu!': 'Ett fel uppstod under uppdatering av etiketter!',
  'Resim başarıyla yüklendi!': 'Bilden laddades upp framgångsrikt!',
  'Resim yüklendi ama ürün güncellenemedi!': 'Bilden laddades upp men produkten kunde inte uppdateras!',
  'Resim yüklenirken hata oluştu!': 'Ett fel uppstod under biluppladdning!',
  'Ürün başarıyla güncellendi!': 'Produkten uppdaterades framgångsrikt!',
  'Ürün güncellenirken hata oluştu!': 'Ett fel uppstod under produktuppdatering!',
  'Hata:': 'Fel:',
  'Güncelleme hatası:': 'Uppdateringsfel:',
  'Alanlar yüklendi:': 'Fält laddade:',
  'alan': 'fält',
  'Connect Free!': 'Anslut gratis!',
  'En çok tercih edilen ürünlerimizi keşfedin': 'Upptäck våra mest populära produkter',
  'Tüm Kategoriler': 'Alla kategorier',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48 produkter visas (Totalt: 8000+)',
  'Tüm Ürünleri Gör →': 'Se alla produkter →',
  'Detaylar': 'Detaljer',
  'Sipariş Ver': 'Beställ nu',
  'Giriş Yap': 'Logga in',
  'Hesabınıza giriş yapın': 'Logga in på ditt konto',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'Denna webbplats skyddas av reCAPTCHA och Google Privacy Policy och Terms of Service gäller.',
  'Ürün Kataloğumuz': 'Vår produktkatalog',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': 'Vi erbjuder över 8000 produkter',
  '1,3B': '1,3K',
  'Partner': 'Partner',
  '8,4M': '8,4M',
  'Toplam Üretim': 'Total produktion',
  '23': '23',
  'Branş': 'Gren',
  '27,5B': '27,5K',
  'Toplam Sipariş': 'Totala beställningar',
  'Connect Now': 'Anslut nu',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'Registrera dig gratis för att komma åt all information på ett ställe.',
  'Ürün Detayları': 'Produktdetaljer',
  'Kapat': 'Stäng',
  'Yükleniyor...': 'Laddar...',
  'Hata': 'Fel',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}} produkter visas (Totalt: 8000+)',
  'Şehir Seçimi': 'Stadsval',
  'Firma / Sağlık Profesyoneli': 'Företag / Hälsoprofessionell',
  'Yetkili Kişi': 'Auktoriserad Person',
  'Telefon': 'Telefon',
  'E-posta': 'Email',
  'Temel Bilgiler': 'Grundläggande Information',
  'Ek Bilgiler': 'Ytterligare Information',
  'Faaliyet Alanı / Sektör': 'Verksamhetsområde / Sektor',
  'Ülke Seçimi': 'Landsval',
  'Ülke adı veya kodu ara...': 'Sök landnamn eller kod...',
  'region.Avrupa': 'Europa',
  'region.Amerika': 'Amerika',
  'region.Asya': 'Asien',
  'region.Afrika': 'Afrika',
  'region.Okyanusya': 'Oceanien',
  'region.Diğer': 'Andra',
  'country.TR': 'Turkiet',
  'country.US': 'USA',
  'country.DE': 'Tyskland',
  'country.FR': 'Frankrike',
  'country.GB': 'Storbritannien',
  'country.IT': 'Italien',
  'country.ES': 'Spanien',
  'country.RU': 'Ryssland',
  'country.CN': 'Kina',
  'country.JP': 'Japan',
  'country.KR': 'Sydkorea',
  'country.IN': 'Indien',
  'country.BR': 'Brasilien',
  'country.CA': 'Kanada',
  'country.AU': 'Australien',
  'Ticaret Sicil No': 'Handelsregistreringsnummer',
};
